import React from 'react';

interface IStudyOverlay {
	show: boolean,
	top: number,
	left: number,
}

interface IOverlayMenuProps {
	studyOverlay: IStudyOverlay,
	openStudyModal: () => void,
	removeStudyAndSave: () => void,
}

export const OverlayMenu: React.FunctionComponent<IOverlayMenuProps> = ({ studyOverlay, openStudyModal, removeStudyAndSave }) => {
	if (studyOverlay && studyOverlay.show) {
		return (
			<span className="overlayMenu" style={{ top: studyOverlay.top, left: studyOverlay.left }}>
				<div className="edit" onClick={openStudyModal}>
					Edit settings...
				</div>
				<div className="delete" onClick={removeStudyAndSave}>
					Delete study
				</div>
			</span>
		);
	}
	return <span />;
};